import useLocale from 'next-translate/useTranslation';

/** The language question, asked the same way on every industry page. */
export function useLanguagesFaq() {
  const { t } = useLocale('bot-use-cases');

  return {
    question: t('Which languages does it speak?'),
    answer: t(
      'It answers in the language each person writes in, more than 80 of them, from the same knowledge.',
    ),
  };
}
